// Super admin: list all companies (optional countryCode filter via ListPagedInput)
export const getAllCompaniesSuperAdminQuery = `
  query GetAllCompaniesSuperAdmin($input: ListPagedInput) {
    getAllCompaniesSuperAdmin(input: $input) {
      code
      companies {
        id
        name
        registrationNumber
        businessType
        currencyCode
        address {
          country
          province
          district
          sector
          cell
          village
          streetAddress
        }
        status
      }
    }
  }
`;

export const getCompanyDetailsQuery = `
  query GetCompanyDetails {
    getCompanyDetails {
      code
      company {
        id
        name
        businessType
        currencyCode
        registrationNumber
        description
        address {
          country
          province
          district
          sector
          cell
          village
          streetAddress
        }
        status
      }
    }
  }
`;

export const updateCompanyStatusMutation = `
  mutation UpdateCompanyStatus($input: UpdateCompanyStatusInput!) {
    updateCompanyStatus(input: $input) {
      code
      company {
        id
        name
        registrationNumber
        status
      }
    }
  }
`;

export const updateCompanyQuery = `
  mutation UpdateCompany($input: UpdateCompanyInput!) {
    updateCompany(input: $input) {
      code
      company {
        name
        businessType
        currencyCode
        registrationNumber
        description
        address {
          country
          province
          district
          sector
          cell
          village
          streetAddress
        }
      }
    }
  }
`;
